import axios from 'axios';
import jwtDecode from 'jwt-decode';

import {
    GET_ERRORS,
    SET_CURRENT_USER,
    SET_CURRENT_STUDENT,
    PASSWORD_RESET,
    PASSWORD_RESETED,
    SET_UNAUTHORIZED_TEACHER,
    SERVER_NOTIFICATIONS,
} from './actionTypes';
// import { toggleModal } from './uiActions';
import { GET_FATAL_ERRORS } from 'store/actions/actionTypes';

import { showNotification } from 'store/actions/uiActions';

import sendAnalytics from 'utils/analytics';
import moment from 'moment';

//Login - get user login
export const loginTeacher = (teacherData) => async (dispatch) => {
    try {
        const result = await axios.post('/api/v3/auth/login', teacherData, { withCredentials: true });

        if (result) {
            //Save to local storage

            const { success, redirect } = result.data;
            if (success) {
                //unauthorized is set false when loading teacher and redirected to login
                dispatch({ type: SET_UNAUTHORIZED_TEACHER, payload: false });

                window.location.href = redirect;
            }
        }
    } catch (err) {
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data || 'We are having some trouble. Please wait a minute and try again.',
        });
    }
};

export const loginAsTeacher = (teacherId) => async (dispatch) => {
    try {
        const result = await axios.post('/api/teachers/loginAs', { teacherId });

        if (result) {
            //Save to local storage

            const { token } = result.data;

            const decoded = jwtDecode(token);

            //unauthorized is set false when loading teacher and redirected to login
            dispatch({ type: SET_UNAUTHORIZED_TEACHER, payload: false });

            if (moment(decoded.expiryDate).diff(moment()) < 0) {
                window.location.href = '/teacher/profile';
            }

            window.location.href = '/teacher';
        }
    } catch (err) {
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data,
        });
    }
};

export const loginStudent = (studentData, history) => async (dispatch) => {
    try {
        const result = await axios.post('/api/v3/auth/login', studentData);

        if (result) {
            const { token } = result.data;
            return token;
        }
    } catch (err) {
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data,
        });
    }
};

//Set Logged in user
export const setCurrentTeacher = (decoded) => {
    return {
        type: SET_CURRENT_USER,
        payload: decoded,
    };
};

export const setCurrentStudent = (decoded) => {
    return {
        type: SET_CURRENT_STUDENT,
        payload: decoded,
    };
};

//Log out user
export const logOutTeacher = (studentData) => async (dispatch) => {
    // If student data is provided we don't want to log out the teacher, but login as the student.
    /**@TODO - Split this into a separate redux action. */
    if (studentData) {
        // Fetch a student token and redirect to student app.
        const studentToken = await dispatch(loginStudent(studentData));
        let loginLink = `//student.lifeskillsgo.com/teacher/${studentToken}`;

        if (window.location.hostname.includes('lifeskillsgo') && window.location.hostname.includes('staging')) {
            loginLink = `//student-staging.lifeskillsgo.com/teacher/${studentToken}`;
        } else if (!window.location.hostname.includes('lifeskillsgo')) {
            loginLink = `//localhost:3001/teacher/${studentToken}`;
        }

        //send analyitcs for teacher logging out
        sendAnalytics(
            {
                area: 'TEACHERS',
                action: 'LOG_IN_AS_STUDENT',
                classId: null,
                params: studentData,
            },
            true
        );

        //open the student on new tab
        window.open(loginLink);
    } else {
        ///remove all data from localStorage and session Storage
        localStorage.removeItem('apc_user_id');
        localStorage.removeItem('apc_local_id');
        localStorage.clear();

        // remove unauthorized redux state if set previously
        dispatch({ type: SET_UNAUTHORIZED_TEACHER, payload: false });

        //send analyitcs for teacher logging out
        sendAnalytics(
            {
                area: 'AUTH',
                action: 'LOG_OUT',
                classId: null,
                params: null,
            },
            true
        );

        window.location.href = '/';
    }
    return;
};

export const validateToken = (token) => async (dispatch) => {
    try {
        //teacher/updateEmail
        const result = await axios.get(`/api/teachers/verify/${token}`);
        return result.data;
    } catch (err) {
        dispatch({
            type: GET_FATAL_ERRORS,
            payload: err,
        });
    }
};

export const register = (data, history) => async (dispatch) => {
    try {
        ///teacher/updateEmail/
        const result = await axios.post('/api/teachers/finishRegister', data);

        if (result) {
            dispatch({
                type: SERVER_NOTIFICATIONS,
                payload: {
                    content: 'You have been registered successfully! You will be redirected to login page shortly.',
                    children: [],
                    timeOut: 3000,
                },
            });
            setTimeout(() => {
                history.push('/');
            }, 3000);
        }
    } catch (err) {
        dispatch({
            type: GET_FATAL_ERRORS,
            payload: err,
        });
    }
};

export const forgotPassword = (data, history) => async (dispatch) => {
    try {
        const result = await axios.post('/api/users/forgotPassword', data);

        if (result.data === true) {
            dispatch({
                type: PASSWORD_RESET,
                payload: result,
            });
            history.push('/');
        } else {
            return false;
        }
    } catch (err) {
        dispatch({
            type: GET_FATAL_ERRORS,
            payload: err,
        });
    }
};

export const resetPassword = (data, history) => async (dispatch) => {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post('/api/users/resetPassword', data);

            if (result.status === 200 && result.data[0] === 1) {
                dispatch({
                    type: PASSWORD_RESETED,
                    payload: result.data,
                });
                history.push('/');
                resolve(result.data);
            } else {
                if (result.data.hasOwnProperty('errors')) {
                }
                //set errors for failing to update
                dispatch({
                    type: GET_ERRORS,
                    payload: result.data.errors.message,
                });
                reject(false);
            }
        } catch (err) {
            console.log(err);
            dispatch({
                type: GET_FATAL_ERRORS,
                payload: err,
            });
            dispatch({
                type: GET_ERRORS,
                payload: 'failed to change password',
            });
            reject(false);
        }
    });
};
